<!--
**CAROUSEL CONTAINER**

main class: criteria-carousel-container

-----
Class: disabled
-----
add this class to disable the slide (removes mouse events and adds opacity)


**VN-CAROUSEL**

-----
Class: single-prize
-----
add this class to adapt the markers for the prizes when they are completed and there's only one prize
the default would be with no class (multi-prize)

**VN-CAROUSEL-ITEM**

Props(?)
- progress in number 0-100 (to fill the width of the active step - in the example below replace the "70%")
- thumb image for the progress slider
- text for the markers in te slider
- image background
- slab image

"single-slab"

the slider adapts automatically when there's only on "carousel-item" - it must have the class "active" to work properly
the slidersperView/Group must be also changed to 1 -> adjust it with javascript -> slidesPerView "1", slidesPerGroup "1"

-----
Class: completed
-----
changes slab dot to "green"
slider width will be overrided with the filled color
dot will be hidden

-----
Class: active
-----
changes slab dot to "green"
slider width will be the same width as recieved in the PROP

-----
Class: locked
-----
changes slab dot to "locked/gray"
slider width will be 0 - no progress yet
dot will be hidden
change text opacity to .5

-->
<ng-container *ngrxLet="vm$ as vm">
    @if (vm) {
        <div class="criteria-carousel-container" [class.disabled]="vm.isMyProgressDisabled">
            <div class="criteria-carousel-container-bg">
                <img class="criteria-carousel-container-img" [src]="vm.myProgress?.carouselBackGroundImage?.src" />
            </div>
            <div class="vn-carousel" [ngClass]="{ 'single-prize': vm.isSingleSlab }">
                @if (arrows && vm.myProgress?.slabContent) {
                    <ds-arrow
                        class="ph-carousel-previous"
                        role="button"
                        [size]="dsComponents?.dsArrow?.size"
                        direction="left"
                        aria-label="Previous slide" />
                    <ds-arrow class="ph-carousel-next" role="button" [size]="dsComponents?.dsArrow?.size" direction="right" aria-label="Next slide" />
                }
                <div #swiperContainer class="swiper">
                    <div class="swiper-wrapper">
                        @for (slab of vm.myProgress?.slabContent; track slab; let i = $index) {
                            <div class="swiper-slide">
                                <div
                                    [ngClass]="{
                                        'carousel-item-hero': isPopperOpen && clickedSlab === i,
                                        'completed': slab.isSlabCompleted && !slab.isCurrentSlab,
                                        'active': slab.isCurrentSlab,
                                        'locked': !slab.isCurrentSlab && !slab.isSlabCriteriaMet,
                                    }">
                                    @if (vm.rewardsContent?.prizes) {
                                        <criteria-slab
                                            (onPopperChange)="checkPopperState($event, i)"
                                            [slabContent]="slab"
                                            [isDisabled]="vm.isMyProgressDisabled"
                                            [rewardContent]="
                                                (slab.isDefaultSlab ? '' : i === 0) ? vm.rewardsContent?.prizes[i] : vm.rewardsContent?.prizes[i - 1]
                                            "
                                            [slabImage]="slab.isDefaultSlab ? vm.myProgress?.firstSlabImage : vm.myProgress?.slabImage">
                                        </criteria-slab>
                                    }
                                    <criteria-steps
                                        [stepDescription]="slab.content"
                                        [stepImage]="vm.myProgress?.stepImage"
                                        [stepPercentage]="slab.slabPercentage">
                                    </criteria-steps>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    }
</ng-container>
